import { render, staticRenderFns } from "./WarningContent.vue?vue&type=template&id=fdd73abc&scoped=true&"
import script from "./WarningContent.vue?vue&type=script&lang=js&"
export * from "./WarningContent.vue?vue&type=script&lang=js&"
import style0 from "./WarningContent.vue?vue&type=style&index=0&id=fdd73abc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd73abc",
  null
  
)

export default component.exports